import axios from "@/api/axiosInstance";
import { CreateSpecialtyRequest, CreateSpecialtyResponse } from "./types";

export const createSpecialty = async (
  requestData: CreateSpecialtyRequest,
): Promise<CreateSpecialtyResponse> => {
  const response = await axios.post<CreateSpecialtyResponse>(
    "/api/private/employee-directory/specialties",
    requestData,
  );
  return response.data;
};
